var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#272835;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "17-Communication") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_17-Communication",
    "data-name": "17-Communication"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.19,46.6a1,1,0,0,0,.8.4h0a1,1,0,0,0,.8-.4L21.5,43H32a4,4,0,0,0,4-4V4a4,4,0,0,0-4-4H4A4,4,0,0,0,0,4V39a4,4,0,0,0,4,4H14.5Zm-11.09-19-1,2A1,1,0,0,0,5,30V41H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,2H32a2,2,0,0,1,2,2V39a2,2,0,0,1-2,2H31V30a1,1,0,0,0-.11-.45l-1-2a1,1,0,0,0-.5-.47l-6.63-2.87-.54-1.67A8.2,8.2,0,0,0,25,16V8a1,1,0,0,0-.29-.71A9.73,9.73,0,0,0,18,5a9.73,9.73,0,0,0-6.71,2.29A1,1,0,0,0,11,8v8a8.2,8.2,0,0,0,2.77,6.54l-.54,1.67L6.6,27.08A1,1,0,0,0,6.11,27.55ZM18,22c-3.69,0-5-3.23-5-6V14.91A3.55,3.55,0,0,0,15.82,13h4.36A3.55,3.55,0,0,0,23,14.91V16C23,18.77,21.69,22,18,22Zm2.84,2.75L18,27.59l-2.84-2.84.38-1.19a7,7,0,0,0,4.9,0ZM13,12.86V8.47A8.3,8.3,0,0,1,18,7a8.3,8.3,0,0,1,5,1.47v4.39c-.5-.13-1-.38-1-.86a1,1,0,0,0-1-1H15a1,1,0,0,0-1,1C14,12.47,13.5,12.72,13,12.86ZM10,37v4H7V30.24l.73-1.46,6-2.61L17,29.41V33h2V29.41l3.25-3.25,6,2.61L29,30.24V41H26V37H24v4H21a1,1,0,0,0-.8.4L18,44.34,15.8,41.4A1,1,0,0,0,15,41H12V37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60,21H52.5l-2.71-3.61A1,1,0,0,0,49,17h0a1,1,0,0,0-.8.4L45.5,21H38v2h8a1,1,0,0,0,.8-.4L49,19.66,51.2,22.6a1,1,0,0,0,.8.4h8a2,2,0,0,1,2,2V60a2,2,0,0,1-2,2H59V51a1,1,0,0,0-.11-.45l-1-2a1,1,0,0,0-.5-.47l-6.63-2.87-.54-1.67A8.2,8.2,0,0,0,53,37V29a1,1,0,0,0-.29-.71A9.73,9.73,0,0,0,46,26a9.73,9.73,0,0,0-6.71,2.29A1,1,0,0,0,39,29v8a8.2,8.2,0,0,0,2.77,6.54l-.54,1.67L34.6,48.08a1,1,0,0,0-.5.47l-1,2A1,1,0,0,0,33,51V62H32a2,2,0,0,1-2-2V45H28V60a4,4,0,0,0,4,4H60a4,4,0,0,0,4-4V25A4,4,0,0,0,60,21ZM41,29.47A8.3,8.3,0,0,1,46,28a8.3,8.3,0,0,1,5,1.47v4.39c-.5-.13-1-.38-1-.86a1,1,0,0,0-1-1H43a1,1,0,0,0-1,1c0,.47-.5.72-1,.86ZM41,37V35.91A3.55,3.55,0,0,0,43.82,34h4.36A3.55,3.55,0,0,0,51,35.91V37c0,2.77-1.31,6-5,6S41,39.77,41,37Zm7.84,8.75L46,48.59l-2.84-2.84.38-1.19a7,7,0,0,0,4.9,0ZM57,62H54V58H52v4H40V58H38v4H35V51.24l.73-1.46,6-2.61L45,50.41V54h2V50.41l3.25-3.25,6,2.61L57,51.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4,
    y: 4,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30,
    y: 4,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58,
    y: 25,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49,15a4,4,0,1,0-4-4A4,4,0,0,0,49,15Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,49,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,49a4,4,0,1,0,4,4A4,4,0,0,0,18,49Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,18,55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/membership.b53bbe5a7c90666cc893ff9b4bc2d379.svg";
export { ForwardRef as ReactComponent };